import './form.css'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import { loginUser } from '../../redux/apiCalls/authApiCall'

const Login = () => {
	const dispatch = useDispatch()
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')

	const formSubmitHandler = (e) => {
		e.preventDefault()
		if (email.trim() === '') return toast.error('Email is required')
		if (password.trim() === '') return toast.error('Password is required')
		dispatch(loginUser({ email, password }))
	}

	return (
		<section className="form-page-bg">
			<div className="form-container">
				<form onSubmit={formSubmitHandler} className="form">
					<h1 className="form-title">Login to your account</h1>

					<div className="form-group">
						<label htmlFor="email" className="form-label">
							Email
						</label>
						<input
							onChange={(e) => setEmail(e.target.value)}
							value={email}
							type="email"
							id="email"
							placeholder="Enter your email"
							className="form-input"
						/>
					</div>

					<div className="form-group">
						<label htmlFor="password" className="form-label">
							Password
						</label>
						<input
							onChange={(e) => setPassword(e.target.value)}
							value={password}
							type="password"
							id="password"
							placeholder="Enter your password"
							className="form-input"
						/>
					</div>

					<button type="submit" className="form-btn">
						Login
					</button>

					<div className="form-footer">
						Did you forget your password?{' '}
						<Link to="/forgot-password">Reset it here</Link>
					</div>
				</form>
			</div>
		</section>
	)
}

export default Login
